"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.rowActionTypes = exports.dataTypes = exports.columnHideOptions = exports.TABLET = exports.STRING = exports.ROW_MENU = exports.ROW_ICON = exports.ROW_BUTTON = exports.PHONE = exports.NUMBER = exports.DESCENDING = exports.DATE_TIME = exports.DATE_STRING = exports.DATE = exports.CURRENCY = exports.BULK_ACTION = exports.BOOLEAN = exports.ASCENDING = exports.ACTION = void 0;
///// Table Constants /////
var PHONE = 'phone';
exports.PHONE = PHONE;
var TABLET = 'tablet';
exports.TABLET = TABLET;
var STRING = 'string';
exports.STRING = STRING;
var NUMBER = 'number';
exports.NUMBER = NUMBER;
var DATE = 'date';
exports.DATE = DATE;
var DATE_STRING = 'dateString';
exports.DATE_STRING = DATE_STRING;
var DATE_TIME = 'dateTime';
exports.DATE_TIME = DATE_TIME;
var CURRENCY = 'currency';
exports.CURRENCY = CURRENCY;
var BOOLEAN = 'boolean';
exports.BOOLEAN = BOOLEAN;
var ACTION = 'action';
exports.ACTION = ACTION;
var ASCENDING = 'asc';
exports.ASCENDING = ASCENDING;
var DESCENDING = 'desc';
exports.DESCENDING = DESCENDING;
var ROW_MENU = 'menu';
exports.ROW_MENU = ROW_MENU;
var ROW_ICON = 'icon';
exports.ROW_ICON = ROW_ICON;
var ROW_BUTTON = 'button';
exports.ROW_BUTTON = ROW_BUTTON;
var BULK_ACTION = 'bulk';
exports.BULK_ACTION = BULK_ACTION;
var types = {
  ASCENDING: ASCENDING,
  DESCENDING: DESCENDING
};
exports.types = types;
var dataTypes = {
  STRING: STRING,
  NUMBER: NUMBER,
  DATE: DATE,
  DATE_STRING: DATE_STRING,
  DATE_TIME: DATE_TIME,
  CURRENCY: CURRENCY,
  BOOLEAN: BOOLEAN,
  ACTION: ACTION
};
exports.dataTypes = dataTypes;
var columnHideOptions = {
  PHONE: PHONE,
  TABLET: TABLET
};
exports.columnHideOptions = columnHideOptions;
var rowActionTypes = {
  ROW_MENU: ROW_MENU,
  ROW_ICON: ROW_ICON,
  ROW_BUTTON: ROW_BUTTON,
  BULK_ACTION: BULK_ACTION
};
exports.rowActionTypes = rowActionTypes;